<template>
  <div>

    <customSidebar
      :visible="showSidebar"
      :is-dark-mode="isDarkMode"
      @close="showSidebar = false"
      @toggle-theme="toggleTheme"
    />

    <headerAll @toggle-sidebar="showSidebar = !showSidebar" />
    <router-view></router-view>

    <customModal v-for="(modal, index) in openModals" :key="index" @close="closeModal(index)">
      <component :is="modal.component" :datapass="modal.data" @close="closeModal(index)" />
    </customModal>

  </div>
</template>

<script>
import { ref, markRaw, provide, computed } from 'vue'; // Certifique-se de que `computed` foi importado
import customModal from './components/customModal.vue';
import customSidebar from './components/customSidebar.vue';
import headerAll from './components/headerAll.vue';


export default {
  name: 'App',
  components: { customModal, headerAll, customSidebar },
  setup() {
    const modals = ref([]);
    const showSidebar = ref(false);
    const isDarkMode = ref(localStorage.getItem("theme") === "dark");

    function openModal(component, data = null) {
      const newModal = {
        component: markRaw(component),
        data, // Armazena dados como ordens selecionadas
        isOpen: true,
      };
      modals.value.push(newModal);
    }

    function closeModal(index) {
      modals.value[index].isOpen = false;
      modals.value.splice(index, 1);
    }

    function toggleTheme() {
      isDarkMode.value = !isDarkMode.value;
      document.body.classList.toggle("dark-mode", isDarkMode.value);
      localStorage.setItem("theme", isDarkMode.value ? "dark" : "light");
    }

    // Computed property para retornar apenas os modais abertos
    const openModals = computed(() => modals.value.filter(modal => modal.isOpen));

    provide('openModal', openModal);
    provide('closeModal', closeModal);

    return { modals, openModals, openModal, closeModal, showSidebar, isDarkMode, toggleTheme};
  },
  mounted() {
      this.$store.dispatch('startWebSocketConnection');

      if (localStorage.getItem("theme") === "dark") {
        document.body.classList.add("dark-mode");
      }
  }
};

</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Geist:wght@100..900&display=swap');

* {
  font-family: "Geist", sans-serif;
  font-weight: 400;
  margin: 0;
  padding: 0;
  text-align: left;
  line-height: 1.2;
  font-size: 0.84rem;
  letter-spacing: normal;
  box-sizing: border-box;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
}

:root {
  --body-color: #e8e8e8;
  --text-color: #000000;
  --border-color: #d0d0d0;
  --box-section-bgcolor: #f4f4f4;
  --sellcard-bgcolor: #f8d7da;
  --buycard-bgcolor: #d4edda;
  --susprebuycard-bgcolor: #dbe3e9;
  --completedorder-bgcolor: #efefef;
  --table-header-bgcolor: #d7d7d7;
  --table-row: #f9f9f9;
  --table-row-hover: #e9e9e9;
  --striped-row: #e8e8e8;
  --button-normal-bgcolor: #7417a4;
  --button-dark-bgcolor: #3a3a3a;
  --button-dark-hover-bgcolor: #555555;
}

.dark-mode {
  --body-color: #221f1f;
  --text-color: #ffffff;
  --border-color: #313131;
  --box-section-bgcolor: #181a20;
  --sellcard-bgcolor: #9d1f256b;
  --buycard-bgcolor: #0f652d57;
  --susprebuycard-bgcolor: #475d6a;
  --completedorder-bgcolor: #3a3838;
  --table-header-bgcolor: #181a20;
  --checkbox-color-checked: #28a745;
  --table-row: #303030;
  --table-row-hover: #3f3f3f;
  --striped-row: #3f3f3f;
  --button-normal-bgcolor: #bbafaf;
  --button-dark-bgcolor: #2a2a2a;
  --button-dark-hover-bgcolor: #646161;
  --button-success-bgcolor: #28a745;
  --button-danger-bgcolor: #dc3545;
}

body {
  background-color: var(--body-color);
  color: var(--text-color);
}

*::-webkit-scrollbar {
  width: 6px;
  height: 4px;
}

*::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}

.pl-10 {
  padding-left: 10px;
}

.mt-10 {
  margin-top: 10px;
}

.mb-10 {
  margin-bottom: 10px;
}

.scrollable {
  overflow-y: scroll;
  padding-right: 4px;
}

.container-wrapper {
  width: 96%;
  margin: 5px auto;
}

.container-box {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.text-boxed {
  border: 1px solid var(--border-color);
  padding: 4px 8px;
  border-radius: 4px;
}

.text-with-subtitle h4 {
  font-size: 1.1rem;
}

.text-with-subtitle p {
  margin: 0;
  font-size: 0.85rem;
  color: var(--text-color);
}

.attention {
  color: orange !important;
}

.small-text {
  font-size: 0.8rem;
}

.column-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  font-size: 18px;
  color: var(--text-color);
}

.column-title .icon {
  font-size: 24px;
}

.card-title {
  font-size: 14px;
  font-weight: 700;
  margin: 10px 0;
  color: #e5e7eb;
}

.card-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 13px;
  color: #cbd5e1;
}

.card-row .label {
  opacity: 0.8;
}

.card-row .value {
  font-weight: 700;
  color: #f8fafc;
}

.card-row.subtle .value,
.card-row.subtle .label {
  opacity: 0.7;
}

.divider {
  height: 1px;
  background: rgba(255,255,255,0.08);
  margin: 10px 0;
}

.box-section, .box-rounded {
  background-color: var(--box-section-bgcolor);
  padding: 15px 10px;
  margin: 10px 0;
  width: 100%;
  float: left;
  border-radius: 8px;
}

border-topped {
  border-top: 1px dotted #7418a4;
}

.wrapper-section{
  padding: 10px 20px;
}

input[type="checkbox"] {
    margin: 0 0 10px 10px;
    width: 22px; /* Largura base do checkbox */
    height: 22px; /* Altura base do checkbox */
    border: 1px solid; /* Define a borda */
    border-radius: 50%; /* Arredonda o checkbox */
    appearance: none; /* Remove o estilo padrão do navegador */
    -webkit-appearance: none; /* Para navegadores WebKit */
    cursor: pointer;
  }

input[type="checkbox"]:checked {
    background-color: var(--checkbox-color-checked);
    border-color: var(--checkbox-color-checked);
  }

select, button, input {
  color: var(--text-color);
  background-color: var(--box-section-bgcolor);
  border: 1px solid var(--border-color);
  border-radius: 5px;
}


button {
    padding: 10px 15px;
    border: none;
    color: #fff;
    border-radius: 5px;
    font-size: 14px !important;
    text-align: center;
    background-color: var(--button-success-bgcolor);
    cursor: pointer;
}

button:hover {
    opacity: 0.9;
}

.box-shadow {
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
}

.box-rounded {
    border-radius: 16px;
}

.button-dark {
  background-color: var(--button-dark-bgcolor);
  color: #fff;
}

.button-success {
  background-color: var(--button-success-bgcolor);
  color: #fff;
}

.button-danger {
  background-color: var(--button-danger-bgcolor);
  color: #fff;
}

.positive {
  color: green;
}

.negative {
  color: red;
}

.gray-button {
  color: #131313;
  background-color: #d5d3d3;
}
.gray-button:hover {
  background-color: #c5c3c3;
}
.small-button {
  width: 60px;
  font-size: 12px;
}

.span-button {
  font-size: 12px;
  text-decoration: underline;
}

.span-button:hover{
  cursor: pointer;
}
.form-group {
    margin-bottom: 15px;
  }

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.container {
  max-width: 1200px;
  margin: 60px auto;
  padding: 20px;
  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); */
  border-radius: 8px;
}

.vertical-spacer {
  height: 20px;
  width: 100%;
}

.order-container {
  float: left;
  padding: 10px 18px;
  width: 100%;
  background-color: var(--completedorder-bgcolor);
  margin-bottom: 10px;
  border-radius: 5px;
  position: relative;
}

.buy-order {background-color: var(--buycard-bgcolor);}
.sell-order {background-color: var(--sellcard-bgcolor);}

.orderPrice{
    font-size: 0.85rem;
    padding: 0;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
}

.small-font {
  font-size: 0.75rem;
}

.extrasmall-font {
  font-size: 0.68rem;
}

.left-float {
  float: left;
}

.right-float {
  float: right;
}

.right-breath {
  margin-right: 14px;
}

.left-breath {
  margin-left:14px
}

.full-width {
  float: left;
  width: 100%;
  margin: 10px 0;
}

.align-center {
  text-align: center;
}

.align-right {
  text-align: right;
}

.col-1 {
  width: 24%;
}

.col-2 {
  width: 49%;
}

.col-3 {
  width: 74%;
}

.grid {
  display: grid;
  gap: 20px;
}

.grid-child {
    background-color: var(--table-header-bgcolor);
    padding: 20px;
}

.grid-6 { grid-template-columns: repeat(6, 1fr); }

.grid-5 { grid-template-columns: repeat(5, 1fr); }

.grid-4 { grid-template-columns: repeat(4, 1fr); }

.grid-3 { grid-template-columns: repeat(3, 1fr); }

.grid-2 { grid-template-columns: repeat(2, 1fr); }

.pastorders-container {
  float:left;
  width: 700px;
}

.neworder-container {
  float: right;
  width: 400px;
}

.tabular-header, .tabular-row {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 1fr 1fr 1fr 1fr;
  gap: 8px;
  height: 42px;
  padding: 0 10px;
  align-items: center;
  font-size: 0.97rem;
}

.tabular-header {
  background-color: var(--table-header-bgcolor);
  color: var(--text-color);
  font-weight: bold;
  border-bottom: 2px solid var(--border-color);
  margin-bottom: 4px;
}

.tabular-row {
  border-bottom: 1px solid var(--border-color);
  margin: 3px 0;
  transition: background 0.1s;
}

.tabular-row:hover {
  background-color: var(--table-row-hover);
}

.order-side {
  font-weight: bold;
  font-size: 1.1rem;
  text-transform: uppercase;
}

.order-buy { color: #0f652d; }
.order-sell { color: #9d1f25; }

.status-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.85em;
  font-weight: bold;
  color: #fff;
  text-align: center;
}
.status-partial { background: #17a2b8; }
.status-filled { background: #28a745;}
.status-soldRb { background: #a76e28;}
.status-pending { background: #a73128;}

.bucket-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.85em;
  font-weight: bold;
  color: #fff;
  text-align: center;
}
.bucket-regular { background: #17a2b8; }
.bucket-rebuy { background: #b0ab12;}
.bucket-manual { background: #5d81e2;}
.bucket-sellRegular { background: #9d1f25; }
.bucket-buyRebuy { background: #0f652d;}
.bucket-hedge { background: #f59e0b; }

.qty-cell {
  font-weight: bold;
  background: #222;
  height: 100%;
  width: 84%;
  display: flex;
  font-size: 1.25rem;
  align-items: center;
  border-radius: 4px;
  padding: 10px 0 0 10px !important;
  color: #fff;
}
.qty-buy { background: #0f652d; }
.qty-sell { background: #9d1f25; }


.selo-info {
  background-color: rgb(4, 124, 12);
  color: white;
  position: absolute;
  right: -3px;
  top: -13px;
  padding: 3px 5px;
  border-radius: 3px;
  font-size: 11px;
}

.section-name {
  margin-bottom: 10px;
}

.units-selector {
  height: 600px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.units-label {
  font-size: 11px;
  color: var(--text-secondary, #888);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.units-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tracker-panel {
  background: var(--table-header-bgcolor);
  color: var(--text-color);
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.profit-chip { border-color: #4caf4f60 !important; }
.loss-chip   { border-color: #f4433660 !important; }

.unit-chip {
  position: relative;
}

.unit-badge {
  position: absolute;
  top: -1px;
  right: -1px;
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 0 8px 0 6px;
  background: orange;
  color: #000;
  white-space: nowrap;
  letter-spacing: 0.03em;
}

.profit-positive { color: #4caf50; }
.profit-negative { color: #f44336; }

.empty-msg {
  font-size: 12px;
  color: #666;
}

.unit-chip {
  background: #1a1a1a;
  border: 1px solid #2b2b2b;
  color: #e2e2e2;
  text-align: left;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
}

.unit-chip.selected {
  border-color: #2aa5a1;
  border-left: 5px solid #b89214;
}

.unit-chip.used-elsewhere {
  border-color: #b89214;
  border-left: 5px solid #2aa5a1;
}

.unit-chip.insufficient {
  border-color: red;
  border-left: 5px solid red;
}

.unit-id {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 4px;
}

.unit-sub {
  font-size: 11px;
  margin: 3px 0;
  opacity: 0.8;
}

.metric-card {
  background: #161616;
  border: 1px solid #2b2b2b;
  border-radius: 10px;
  height: 120px;
  margin-bottom: 10px;
  padding: 20px;
}

.metric-card-label {
  font-size: 14px;
  font-weight: bold;
  opacity: 0.85;
  margin-bottom: 6px;
}

.metric-card-value {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 6px;
}

.metric-card-secondary {
  font-size: 12px;
  opacity: 0.8;
}

.manual-orders-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.manual-order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;
}

.manual-order-header .symbol {
  font-weight: bold;
  font-size: 16px;
}

.manual-order-header .exchange {
  background: #6366f1;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  text-transform: uppercase;
}

.manual-order-header .status {
  color: #10b981;
  font-weight: 600;
  font-size: 12px;
}

.manual-order-header .time {
  color: #9ca3af;
  font-size: 12px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 14px;
}

.detail-row .label {
  font-weight: 500;
}

.detail-row .value {
  font-weight: 600;
}

.chart-wrapper {
  height: 100%;
}

.chart-section {
  background-color: var(--table-header-bgcolor);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;
}
.chart-section h3 {
  margin: 0 0 15px 0;
  font-size: 1.2em;
  color: var(--text-color);
}

</style>
